/**
 * It takes a timestamp and returns a string in the format of HH:MM
 * @param {number} timestamp - number - the timestamp to convert
 * @returns A string with the hours and minutes of the timestamp.
 */
export const timestampToString = (timestamp: number): string => {
    const date = new Date(timestamp)

    const minutesFromDate = date.getMinutes().toString()

    return `${date.getHours()}:${minutesFromDate.length === 2 ? minutesFromDate : `0${minutesFromDate}`}`
}

export function hexToRgbA(hex, alpha) {
    let c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = `0x${c.join('')}`
        return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${alpha})`
    }
    throw new Error('Bad Hex')
}
